import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Patch Leaflet to handle React's Suspense/Offscreen re-mounting,
// which re-attaches refs on the same DOM node causing
// "Map container is already initialized" errors.
const originalInitContainer = (L.Map.prototype as any)._initContainer;
(L.Map.prototype as any)._initContainer = function (id: any) {
  const container = typeof id === 'string' ? document.getElementById(id) : id;
  if (container && (container as any)._leaflet_id) {
    delete (container as any)._leaflet_id;
  }
  originalInitContainer.call(this, id);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
